import { IoPeopleSharp } from 'react-icons/io5'
import { retrunAssets, returnNotImage } from '../../utils/getAssets'
import { MdArrowForward } from 'react-icons/md'
import { FaArrowRight, FaDownload } from 'react-icons/fa6'
import { Link } from 'react-router-dom'
import { DecodeHtml } from '../../utils/decodeHtml'
import Heading from '../heading'
import { FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa'

const About = ({ college }) => {
  const blueText = college?.blueText
  const socialsFacebookLink = college?.socialsFacebookLink || ''
  const socialsInstagramLink = college?.socialsInstagramLink || ''
  const socialsYoutubeLink = college?.socialsYoutubeLink || ''
  const collegeDescription = college?.collegeDescription?.markup
  const collegeBuildingImage =
    college?.collegeBuildingImage != null
      ? retrunAssets(college?.collegeBuildingImage[0]?.url)
      : ''
      const collegeBoxes = college?.collegeBoxes?.items || []

      const services = collegeBoxes
      ? [
          {
            icon:
              collegeBoxes[0]?.content?.properties?.icon.length > 0
                ? retrunAssets(collegeBoxes[0]?.content?.properties?.icon[0]?.url)
                : '',
            title: collegeBoxes[0]?.content?.properties?.label,
            externalLink: collegeBoxes[0]?.content?.properties?.externalLinkButton
          },
          {
            icon:
              collegeBoxes[1]?.content?.properties?.icon.length > 0
                ? retrunAssets(collegeBoxes[1]?.content?.properties?.icon[0]?.url)
                : '',
            title: collegeBoxes[1]?.content?.properties?.label,
            route: '/contact us'
          },
          {
            icon:
              collegeBoxes[2]?.content?.properties?.icon.length > 0
                ? retrunAssets(collegeBoxes[2]?.content?.properties?.icon[0]?.url)
                : '',
            title: collegeBoxes[2]?.content?.properties?.label,
            download:
              collegeBoxes[2]?.content?.properties?.downloadFileButton != null
                ? retrunAssets(
                    collegeBoxes[2]?.content?.properties?.downloadFileButton[0]
                      ?.url
                  )
                : ''
          }
        ]
      : []
  return (
    <div className='flex flex-col justify-center gap-16 mb-10 p-4 md:px-10 items-center bg-[#F2F3F4]'>
      <div className='flex flex-col   gap-10 container mt-12'>
        <div className='grid grid-cols-1 lg:grid-cols-2 place-items-center gap-10'>
          <div className='grid grid-cols-1 gap-5'>
            <Heading name={blueText} color='text-blue-700' />
            <img
              src={collegeBuildingImage || returnNotImage()}
              alt='sideImage'
              className='w-full h-full min-h-[30rem] border-2 bg-gray-100 object-cover rounded-lg'
            />
          </div>
          <div className='flex flex-col gap-5'>
            {DecodeHtml({ html: collegeDescription })}
            {/* <div className='flex flex-col gap-4'>
              <h2 className='w-auto  text-slate-900 text-2xl font-bold capitalize'>
                Follow Us
              </h2>
              <div className='py-2 flex gap-5 items-center'>
                <a
                  href={socialsFacebookLink}
                  target='_blank'
                  rel='noreferrer'
                  className='flex items-center justify-center w-7 h-7 2xl:w-10 2xl:h-10 rounded-full bg-[#0039CB1A] text-[#003acbb7] bg-opacity-65 text-white'
                >
                  <FaFacebookF className='text-[#003acbb7]' />
                </a>
                <a
                  href={socialsInstagramLink}
                  target='_blank'
                  rel='noreferrer'
                  className='flex items-center justify-center w-7 h-7 2xl:w-10 2xl:h-10 rounded-full bg-[#0039CB1A] text-[#003acbb7] bg-opacity-65 text-white'
                >
                  <FaInstagram className='text-[#003acbb7]' />
                </a>
                <a
                  href={socialsYoutubeLink}
                  target='_blank'
                  rel='noreferrer'
                  className='flex items-center justify-center w-7 h-7 2xl:w-10 2xl:h-10 rounded-full bg-[#0039CB1A] text-[#003acbb7] bg-opacity-65 text-white'
                >
                  <FaYoutube className='text-[#003acbb7]' />
                </a>
              </div>
            </div> */}
          </div>
        </div>
        <div className='flex  w-full items-center justify-center p-4  translate-y-24'>
          <div className='w-full place-items-stretch grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3  gap-5 '>
            {services?.map((service, index) => (
              <div
                className={`flex flex-col  max-w-[28rem] gap-4 p-4 py-8 bg-white rounded shadow-[rgba(99,_99,_99,_0.2)_0px_2px_8px_0px] `}
                key={index}
              >
                <div className={`flex flex-col gap-4 items-center`}>
                  <img
                    src={service?.icon}
                    className='w-10 h-10 rounded-full bg-gray-200'
                    alt=''
                  />

                  <h2 className='text-slate-900 text-2xl font-bold leading-loose'>
                    {service?.title}
                  </h2>
                  <div className='w-12 h-12 flex items-center justify-center'>
                    {service.externalLink && (
                      <a
                        href={service.externalLink}
                        target='_blank'
                        rel='noreferrer'
                      >
                        <button className='w-12 h-12 flex items-center justify-center rounded-full bg-[#9C0000]'>
                          <FaArrowRight size={20} color='white' />
                        </button>
                      </a>
                    )}
                    {service.route && (
                      <Link to={service.route}>
                        <button className='w-12 h-12 flex items-center justify-center rounded-full bg-[#9C0000]'>
                          <FaArrowRight size={20} color='white' />
                        </button>
                      </Link>
                    )}
                    {service.download && (
                      <a
                        href={service.download}
                        target='_blank'
                        rel='noreferrer'
                        download
                      >
                        <button className='w-12 h-12 flex items-center justify-center rounded-full bg-[#9C0000]'>
                          <FaDownload size={20} color='white' />
                        </button>
                      </a>
                    )}
                    {/* <button className='w-12 h-12 flex items-center justify-center rounded-full bg-[#9C0000]'>
                                                <MdArrowForward size={20} color='white' />
                                            </button> */}
                  </div>
                </div>
              </div>
            ))}
            {/* <div
              className={`flex flex-col  max-w-[28rem] gap-4 p-4 py-8 bg-white rounded `}
            >
              <div className={`flex flex-col gap-4 items-center`}>
                <div className='w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center'>
                  <IoPeopleSharp className='w-8 h-8' />
                </div>

                <h2 className='text-slate-900 text-2xl font-bold leading-loose'>
                  {'Our People'}
                </h2>
                <div className='w-12 h-12 flex items-center justify-center'>
                  <button
                    onClick={() => (modalOpen ? closed() : open())}
                    className='w-12 h-12 flex items-center justify-center rounded-full bg-[#9C0000]'
                  >
                    <MdArrowForward size={20} color='white' />
                  </button>
                </div>
              </div>
            </div>
            <ModelButton css=' text-white' modalOpen={modalOpen} close={closed}>
              <div className='max-w-[80vw] w-full max-h-[90vh]'>
                <OurPeopleDialogue
                  id={college?.collegeId}
                  title={college?.title}
                />
              </div>
            </ModelButton> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default About
